export default "/images/1.png?8308a2fb6d3e525da0f3ce5a8950f173";